module.exports = __webpack_public_path__ + "img/coin.d7424f5f.svg";